import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect () {
    this.reorderMessages()
    this.observeNewMessages()
  }

  disconnect () {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  observeNewMessages () {
    this.observer = new MutationObserver((mutations) => {
      let shouldReorder = false

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches('[data-message-ordering-target="message"]')) {
            shouldReorder = true
          }
        })
      })

      if (shouldReorder) {
        setTimeout(() => this.reorderMessages(), 10)
      }
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  reorderMessages () {
    const current = Array.from(this.messageTargets)
    const sorted = [...current].sort((a, b) => {
      const timeA = new Date(a.dataset.createdAt).getTime()
      const timeB = new Date(b.dataset.createdAt).getTime()
      return timeA - timeB
    })

    const alreadyOrdered = sorted.every((message, index) => message === current[index])
    if (alreadyOrdered) return

    sorted.forEach((message) => {
      this.element.appendChild(message)
    })
  }
}
